import WATERMARK_LOGO from 'url:../img/wl_logo.png';
import SLIDESHOW_BG from 'url:../img/slideshowBg.jpg';
import LOAD_IMG from 'url:../img/load.gif';
import getQueryProvider from './getQueryProvider-module.js';
import occoEvent from './eventManager.js';
import LANG from '../lang/prop-en-module.js';
import occoApi from './occoAPI-module.js';
import { trackPhotoEvent } from './utils/activity.js';
import ImageCompressor from '../libs/js/image-compressor-module.js';
import freedomPayAPI from './freedomPayAPI.js';
import * as customPopUp from './views/modals/customPopUp.js';
import { alertMessagePopup, confirmPopup } from './views/modals/others.js';
import { getValue } from './common-methods.js';
import { vipToken } from './data.js';
import { getWebappDomain } from '../../../packages/src/utils/domain.js';
import { t } from '../../../packages/src/localization/index.js';

export var REAL_IMAGE_PATH = process.env.IMG_PATH;
export var REAL_ASSET_PATH = process.env.ASSET_PATH;
export var SHARING_BODY_TEMPLATE_HTML =
  '<!DOCTYPE html>\r\n<html style="height: 100%;">\r\n<head>\r\n    <meta property="og:url" content="{url}" />\r\n    <meta property="og:type" content="website" />\r\n    <meta property="og:title" content="photo" />\r\n    <meta property="og:description"  content="photo" />\r\n    <meta property="og:image"        content="{imageUrl}" />\r\n    <meta property="og:image:width"  content="{width}" />\r\n    <meta property="og:image:height" content="{height}" />\r\n    <meta property="fb:app_id"       content="696419160565320" />\r\n</head>\r\n<body style="margin: 0px;background: #0e0e0e;height: 100%;">\r\n   <img style=\'\r\n      -webkit-user-select: none;\r\n      margin: auto;\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: contain;\r\n      background-color: hsl(0, 0%, 90%);\r\n      transition: background-color 300ms;\r\n      display: block;\r\n      \'\r\n         src="{srcImg}"\r\n         width="{imgWidth}"\r\n         height="{imgHeight}"\r\n      >\r\n</body>\r\n</html>';
export var SHARING_VIDEO_BODY_TEMPLATE_HTML =
  '<!DOCTYPE html>\r\n<html style="background-color: rgb(0, 0, 0);">\r\n<head>\r\n    <meta property="og:url" content="{url}" />\r\n    <meta property="og:type" content="website" />\r\n    <meta property="og:title" content="video" />\r\n    <meta property="og:description"  content="video" />\r\n    <meta property="og:image"        content="{imageUrl}" />\r\n    <meta property="og:image:width"  content="{width}" />\r\n    <meta property="og:image:height" content="{height}" />\r\n    <meta property="fb:app_id"       content="696419160565320" />\r\n</head>\r\n<body>\r\n   <video controls loop autoplay muted\r\n      name="media"\r\n      style="\r\n         position: absolute;\r\n         top: 0px;\r\n         right: 0px;\r\n         bottom: 0px;\r\n         left: 0px;\r\n         max-height: 100%;\r\n         max-width: 100%;\r\n         margin: auto;\r\n      "\r\n   >\r\n      <source src="{srcVideo}" type="video/mp4">\r\n   </video>\r\n</body>\r\n</html>';
export var SHARING_360_BODY_TEMPLATE_HTML =
  '<!DOCTYPE html>\r\n<html lang="en">\r\n<head>\r\n   <meta charset="utf-8">\r\n   <meta name="viewport" content="width=device-width, initial-scale=1.0">\r\n   <title>OCCO 360 Photo Viewer</title>\r\n   <link rel="shortcut icon" href="/sharing/img/icon.png" type="image/x-icon" />\r\n   <link rel="stylesheet" href="/sharing/css/photo-sphere-viewer.css">\r\n   \r\n    <meta property="og:url" content="{url}" />\r\n    <meta property="og:type" content="website" />\r\n    <meta property="og:title" content="photo" />\r\n    <meta property="og:description"  content="photo" />\r\n    <meta property="og:image"        content="{imageUrl}" />\r\n    <meta property="og:image:width"  content="{width}" />\r\n    <meta property="og:image:height" content="{height}" />\r\n    <meta property="fb:app_id"       content="696419160565320" />\r\n  <style>\r\n     html, \r\n     body {\r\n       width: 100%;\r\n       height: 100%;\r\n       overflow: hidden;\r\n       margin: 0;\r\n       padding: 0;\r\n     }\r\n\r\n     #photosphere {\r\n       width: 100%;\r\n       height: 100%;\r\n     }\r\n\r\n     .psv-button.custom-button {\r\n       font-size: 22px;\r\n       line-height: 20px;\r\n     }\r\n\r\n     .close-button {\r\n       background-image: url(/sharing/img/close.png);\r\n       width: 5px;\r\n       height: 5px;\r\n       margin: 5px 0px 0px 9px;\r\n       cursor: pointer;\r\n     }\r\n\r\n     .watermark {\r\n       background-image: url(/img/watermark.png);\r\n       opacity: 0.2;\r\n       pointer-events: none;\r\n     }\r\n  </style>\r\n</head>\r\n<body>\r\n   <div id="photosphere"></div>\r\n   <script src="https://code.jquery.com/jquery-3.6.0.min.js" integrity="sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=" crossorigin="anonymous"></script>\r\n   <script src="/sharing/js/three.js"></script>\r\n   <script src="/sharing/js/polyfill.js"></script>\r\n   <script src="/sharing/js/uevent.js"></script>\r\n   <script src="/sharing/js/doT.js"></script>\r\n   <script src="/sharing/js/photo-sphere-viewer.js"></script>\r\n   <script>\r\n     var url_string = window.location.href \r\n     var url = new URL(url_string);\r\n     var fileUrl = url.searchParams.get("url");\r\n     var closeable = url.searchParams.get("closeable");\r\n     var wm = url.searchParams.get("wm");\r\n     var closeButton = {\r\n       id: "close",\r\n       title: "back to album",\r\n       className: "close-button",\r\n       onClick: function () {\r\n         window.history.back();\r\n       }\r\n     };\r\n     var closeButtonExist = (closeable === "true") ? closeButton : "caption";\r\n     var PSV = new PhotoSphereViewer({\r\n       container: "photosphere",\r\n       time_anim: false,\r\n       navbar: [\r\n         closeButtonExist,\r\n         "caption",\r\n         "autorotate",\r\n         "zoom",\r\n         "fullscreen"\r\n       ],\r\n       panorama: fileUrl ? fileUrl : "/sharing/img/360_from_todd.jpg"\r\n     });\r\n     if (wm && wm == 111) {\r\n       $(".psv-hud-svg-container").addClass("watermark");\r\n     } else {\r\n       $(".psv-hud-svg-container").removeClass("watermark");\r\n     }\r\n   </script>\r\n</body>\r\n</html>';
export var EMAIL_TEMP =
  '<!DOCTYPE html>\r\n<html>\r\n<body>\r\n    <p>Hi {user_name},</p>\r\n    <p>\r\n        I just put some finishing touches to your photos and I think they look great!\r\n        <br>\r\n        <br><a href="{image_url}">Click here</a> to view, share or download your pictures.\r\n        <br>\r\n        <br />\r\n        Also, I would really appreciate if you took a very brief <a href="https://www.surveymonkey.com/r/V5W58TB">survey</a> that will help me improve!\r\n        <br />\r\n    </p>\r\n    <p>\r\n        Cheers,\r\n        <br><a href="https://www.occo.io">OCCO - the Robot that makes you smile</a>\r\n    </p>\r\n</body>\r\n</html>';
export var EMAIL_SHARING_TEMP =
  "<!DOCTYPE html>\r\n<html>\r\n<body>\r\n<p>Hi,</p>\r\n<p>\r\n {sender_name_or_email} shared some pictures with you that OCCO robot took.\r\n<br>\r\n<br><a href='{image_url}'>Click here</a> to view, share or download!\r\n <br>\r\n</p>\r\n<p>\r\n Cheers,\r\n<br><a href='https://www.occo.io'>OCCO - the Robot that makes you smile</a>\r\n</p>\r\n</body>\r\n</html>";
export var RECEIPT_EMAIL_BODY_TEMP =
  '<!DOCTYPE html>\r\n<html>\r\n<body>\r\n    <p>Hi {user_name},</p>\r\n    <p>\r\n        Thanks for your order. Please find the digital receipt attached.\r\n        <br />\r\n    </p>\r\n    <p>\r\n        Cheers,\r\n        <br><a href="https://www.occo.io">OCCO - the Robot that makes you smile</a>\r\n    </p>\r\n</body>\r\n</html>';
export var SMS_TEMP =
  '\r\n Hi {user_name} \r\n\n I just put some finishing touches to your photos and I think they look great! Your album link is: \r\n\n {image_url}';
export var DEFAULT_WATERMARK = `${REAL_IMAGE_PATH}/watermarks/occo.png`;
export var DEFAULT_LOGO = WATERMARK_LOGO;
export var DEFAULT_SLIDESHOW_BG = SLIDESHOW_BG;
export var MAX_PRINT_COUNT = 20;
export var MIN_PHOTO_AUTO_DELETE_DAYS = 30;
export var MAX_PHOTO_AUTO_DELETE_DAYS = 3000;
export var MAX_PHOTO_STREAM_AVAILABLE_MINUTES = 1000000;
export var DEFAULT_PRINT = 5;
export var DEFAULT_COPIES = 1;

export const DEFAULT_FROM_ADDRESS = getDefaultFromAddress();
export var DEFAULT_NAME = 'OCCO the Robot';
export var DEFAULT_EMAILSUBJECT = 'Your photo from OCCO';
export var DEFAULT_LOGO_LINK = 'https://occo.io';
export var DEFAULT_EVENT_SUPPORT_LINK = 'https://occo.io/contact';
export var PRIVACY_POLICY_LINK = 'https://occo.io/terms/#section3';
export var IMAGES_LINK = 'https://images.occo.io/getPhoto';
export var DEFAULT_PRINTING_CONFIRMATION_TEXT = 'Your photo(s) will be printed and delivered to your event organizer.';
export var DEFAULT_EMAIL_ENDS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'msn.com',
  'mail.com',
  'icloud.com',
  'aol.com',
  'live.com',
];
export var DEFAULT_QR_SIZE = 100;
export var DEFAULT_PIC_SIZE = 250;
export var MAX_WIDTH_VIDEO_PREVIEW = '500px';
export var DEFAULT_EVENT_MULTIPLIER = 1;
export var OCCO_360_VIEWER_PATH = `${REAL_IMAGE_PATH}/360viewer/`;
export var OCCO_IMAGE_PROCESSOR_PATH = 'imageEdit/index.html';
export var DATE_FILTER = {
  active: true,
};
export var SQUARE_ACCESS_TOKEN = null;
export var SQUARE_LOCATIONS = {};
export var SQUARE_DEVICE_COUNT = 0;
export var PAGE_IS_ACTIVE = false;
export var PAGE_IS_ACTIVE_TIMEOUT = 20000;
export const setPageIsActiveTimout = (timeout) => {
  PAGE_IS_ACTIVE_TIMEOUT = timeout;
};

export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/dialog/share?app_id=696419160565320&display=popup&href=';
export const Storage = {
  setLocalItem(key, value) {
    localStorage.setItem(key, value);
  },

  getLocalItem(key) {
    return localStorage.getItem(key);
  },

  removeLocalItem(key) {
    localStorage.removeItem(key);
  },
};
export function elId(id) {
  return document.getElementById(id);
}

export function initStaticTexts() {
  elId('slideShowAlbum').title = LANG.HELP_TEXTS.slide_show_title;
  elId('enablePrinter').innerHTML = LANG.active_printer;
  elId('printEveryPhotoLb').innerHTML = LANG.print_every_photo;
  elId('copiesLabel').innerHTML = LANG.copy_count;
  elId('photosLabel').innerHTML = LANG.photos_count;
  elId('enablePrinterNote').title = LANG.active_printer_note;
  elId('enablePrinterAllAlbumsNote').title = LANG.enable_printer_all_albums_note;
  elId('printEveryPhotoNote').title = LANG.print_every_photo_note;
  elId('printCopiesNote').title = LANG.copy_count_note;
  elId('printPhotosNote').title = LANG.photos_count_note;
  elId('emailBodyHelp').title = LANG.HELP_TEXTS.email_body_title;
  elId('emailBodySharingHelp').title = LANG.HELP_TEXTS.email_body_sharing_title;
  elId('logoLinkHelp').title = LANG.HELP_TEXTS.logo_link_title;
}

export function showContLoading(cont) {
  cont.addClass('screenOverlayCont');
  $('#dotsLoading').show();
}

export function hideContLoading(cont) {
  cont.removeClass('screenOverlayCont');
  $('#dotsLoading').hide();
}

export function showLoading() {
  $('.screenOverlay').show();
  $('#cssload-cupcake').show();
}

export function hideLoading() {
  setTimeout(() => {
    $('#cssload-cupcake').hide();
    $('.screenOverlay').hide();
  }, 100);
}

export function setLoaderToCont(contId) {
  elId(contId).innerHTML = `Loading...<br/><img src="${LOAD_IMG}"/>`;
}

export function hideLoaderToCont(contId) {
  elId(contId).innerHTML = '';
}

export var isMobile = {
  Android() {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry() {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iPhone() {
    return !!navigator.userAgent.match(/iPhone|iPod/i);
  },
  iPad() {
    if (navigator.userAgent.match(/iPad/i)) return true;
    // iPadOS 13+ reports as Mac; detect via UA + touch points
    return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
  },
  iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera() {
    return !!navigator.userAgent.match(/Opera Mini/i);
  },
  Windows() {
    return navigator.userAgent.match(/IEMobile/i) ? true : !!(false || navigator.userAgent.match(/WPDesktop/i));
  },
  any() {
    if (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iPad() ||
      isMobile.iPhone() ||
      isMobile.Opera() ||
      isMobile.Windows()
    ) {
      return true;
    }
    return false;
  },
};

export function iPhoneVersion() {
  const iHeight = window.screen.height;
  const iWidth = window.screen.width;

  if (iWidth === 414 && iHeight === 896) {
    return 'Xmax-Xr';
  }
  if (iWidth === 375 && iHeight === 812) {
    return 'X-Xs';
  }
  if (iWidth === 320 && iHeight === 480) {
    return '4';
  }
  if (iWidth === 375 && iHeight === 667) {
    return '6';
  }
  if (iWidth === 414 && iHeight === 736) {
    return '6+';
  }
  if (iWidth === 320 && iHeight === 568) {
    return '5';
  }
  if (iHeight <= 480) {
    return '2-3';
  }
  return 'none';
}

export function fromUrlFilename(url) {
  if (!url) {
    return url;
  }
  return url.split('/').pop();
}

export function normaliseUrl(url) {
  if (!url) {
    return url;
  }
  const fileName = fromUrlFilename(url);
  return url.replace(fileName, '') + encodeURIComponent(fileName);
}

export function generateRandomFileName(originalFileName, { prefix = '', separator = '_' } = {}) {
  let fileType = '';
  if (originalFileName && originalFileName.lastIndexOf('.') != -1) {
    fileType = originalFileName.substr(originalFileName.lastIndexOf('.') + 1);
  }
  const randomSymbols = Math.random().toString(36).substring(7);
  const prefixString = prefix ? `${prefix}${separator}` : '';
  const res = `${prefixString}${randomSymbols}.${fileType}`;
  return res;
}

export function resizeImage(file, max_width, max_height, filename, callback) {
  // get the image selected
  const item = file;
  // create a FileReader
  const reader = new FileReader();
  // image turned to base64-encoded Data URI.
  reader.readAsDataURL(item);
  reader.name = item.name; // get the image's name
  reader.size = item.size; // get the image's size
  reader.onload = function (event) {
    const img = new Image(); // create a image
    img.src = event.target.result; // result is base64-encoded Data URI
    img.name = event.target.name; // set name (optional)
    img.size = event.target.size; // set size (optional)
    img.onload = function (el) {
      const elem = document.createElement('canvas'); // create a canvas
      // scale the image to 600 (width) and keep aspect ratio
      const MAX_WIDTH = max_width;
      const MAX_HEIGHT = max_height;
      let { width } = img;
      let { height } = img;
      //  if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }
      /*    } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                } */
      elem.width = width;
      elem.height = height;
      // draw in canvas
      const ctx = elem.getContext('2d');
      ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
      // get the base64-encoded Data URI from the resize image
      const srcEncoded = ctx.canvas.toDataURL(el.target, 'image/jpeg');
      const file = dataURLtoFile(srcEncoded, filename);
      callback(file, srcEncoded);
    };
  };
}

export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg',
  });
}

export function customImageUpload(file, opt) {
  let maxWidth = 2000;
  let maxHeight = 2000;
  const keepOriginName = opt.keepOriginName || null;
  if (file) {
    let fileName = modifyExtensionToLowercase(file.name);
    if (!/\.(gif|jpg|jpeg|mp4|png)$/i.test(fileName)) {
      alertMessagePopup(LANG.unsupported_pic_format);
      return;
    }
    if (opt.generateFileName) {
      fileName = generateRandomFileName(fileName, { prefix: opt.prefixFileName });
    }

    if (getQueryProvider.ALBUM_TYPES.isAttendeeAlbum && opt.opts) {
      if (opt.opts.attPhotoImgMaxWidth) {
        maxWidth = opt.opts.attPhotoImgMaxWidth;
      }
      if (opt.opts.attPhotoImgMaxHeight) {
        maxHeight = opt.opts.attPhotoImgMaxHeight;
      }
    }
    new ImageCompressor(file, {
      checkOrientation: false,
      quality: 0.9,
      maxWidth,
      maxHeight,
      convertSize: Infinity,
      mimeType: getContentType(fileName),
      success(result) {
        const fileResized = result;
        occoApi.customPhotoTmpUploadAccessRetrieve(
          opt.eventName,
          fileName,
          keepOriginName,
          opt.attendeeUid,
          (err, result) => {
            if (err) {
              return alert(err.message_key);
            }
            if (opt.callbackAdd) {
              opt.callbackAdd(URL.createObjectURL(fileResized));
            }
            uploadFileToS3(fileResized, result.fields.key, result.url, result.fields, opt.callbackSuccess);
          }
        );
      },
      error(e) {
        console.log(e.message);
      },
    });

    function getContentType(filename) {
      const extension = filename.split('.').pop().toLowerCase();

      const mimeTypes = {
        gif: 'image/gif',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        mp4: 'video/mp4',
        png: 'image/png',
      };

      return mimeTypes[extension] || 'image/jpeg';
    }

    function modifyExtensionToLowercase(filename) {
      if (!filename.includes('.')) return filename;
      const parts = filename.split('.');
      const name = parts.slice(0, -1).join('.');
      const extension = parts.pop().toLowerCase();
      return `${name}.${extension}`;
    }
    /*   resizeImage(file, 1500, 1500, fileName, function (fileResized, src) {
               occoApi.customPhotoTmpUploadAccessRetrieve(opt.eventName, fileName, function (err, result) {
                   if (err) {
                       return alert(err.message_key);
                   }
                   if (opt.callbackAdd) {
                       opt.callbackAdd(src);
                   }
                   uploadFileToS3Test(fileResized, result.fields.key, result.url, result.fields, opt.callbackSuccess);
               });

           }); */
  }
}

export function kioskBGUploader(file, opt) {
  const mp4FileSizeLimit = 4; // mb
  const jpgFileSizeLimit = 1.5; // mb
  if (file) {
    let fileName = file.name;
    if (!/\.(jpg|jpeg|mp4)$/i.test(fileName)) {
      alertMessagePopup(LANG.unsupported_pic_format);
      return;
    }
    const fileExt = file.name.split('.').pop();
    const fileSize = file.size / 1024 / 1024; // to MB
    console.log(fileSize);
    if (fileExt === 'mp4' && fileSize > mp4FileSizeLimit) {
      alertMessagePopup(LANG.unsupported_pic_size);
      return;
    }
    if ((fileExt === 'jpg' || fileExt === 'jpg') && fileSize > jpgFileSizeLimit) {
      alertMessagePopup(LANG.unsupported_pic_size);
      return;
    }
    if (opt.generateFileName) {
      fileName = generateRandomFileName(fileName);
    }
    let rootPath = '/kioskMedia';
    if (opt.fileRootPath) {
      rootPath = opt.fileRootPath;
    }
    const fileRelativePath = `${rootPath}/${opt.eventName}/${fileName}`;
    occoApi.assetTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
      if (err) {
        return alert(err.message_key);
      }
      if (opt.callbackAdd) {
        opt.callbackAdd(URL.createObjectURL(file));
      }

      uploadFileToS3(file, result.fields.key, result.url, result.fields, opt.callbackSuccess);
    });
  }
}

export function profilePhotImageUpload(file, opt) {
  if (file) {
    let fileName = file.name;
    if (!/\.(gif|jpg|jpeg|mp4|png)$/i.test(fileName)) {
      alertMessagePopup(LANG.unsupported_pic_format);
      return;
    }
    if (opt.generateFileName) {
      fileName = generateRandomFileName(fileName);
    }

    let rootPath = '/';
    if (opt.fileRootPath) {
      rootPath = opt.fileRootPath;
    }
    const fileRelativePath = `${rootPath}/${fileName}`;
    new ImageCompressor(file, {
      checkOrientation: false,
      quality: 0.9,
      maxWidth: 1500,
      convertSize: Infinity,
      mimeType: 'image/jpeg',
      success(result) {
        const fileResized = result;
        occoApi.profilePhotoTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
          if (err) {
            return alert(err.message_key);
          }
          if (opt.callbackAdd) {
            opt.callbackAdd(URL.createObjectURL(fileResized));
          }
          uploadFileToS3(fileResized, result.fields.key, result.url, result.fields, opt.callbackSuccess);
        });
      },
      error(e) {
        console.log(e.message);
      },
    });
  }
}

export function uploadFileToS3(file, s3key, s3bucketUrl, s3fields, callbackSuccess, callbackError) {
  const fd = new FormData();
  fd.append('key', s3key);
  fd.append('acl', 'public-read');
  fd.append('success_action_status', '201');
  let fileType = 'image/jpeg';
  if (file.type && file.type != '') {
    fileType = file.type;
  }
  fd.append('Content-Type', fileType);
  fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
  fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
  fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
  fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
  fd.append('Policy', s3fields.Policy);
  fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
  fd.append('file', file);

  const xhr = new XMLHttpRequest();

  // xhr.upload.addEventListener("progress", uploadProgress, false);
  xhr.addEventListener(
    'load',
    (res) => {
      if (xhr.status >= 200 && xhr.status < 300) {
        // Success (2xx status)
        let finalPath = `${REAL_IMAGE_PATH}/${s3key}`;
        if (callbackSuccess) {
          if (s3fields.bucket) {
            finalPath = `https://${s3fields.bucket}/${s3key}`;
          }
          callbackSuccess(finalPath);
        }
      } else {
        // parse XML response text
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xhr.responseText, 'text/xml');
        // Extract error information from XML
        const code = xmlDoc.getElementsByTagName('Code')[0].textContent;
        const message = xmlDoc.getElementsByTagName('Message')[0].textContent;
        const error = { code, message };

        // HTTP error (4xx/5xx like 400, 404, 500, etc.)
        callbackError(error);
      }
    },
    false
  );

  // xhr.addEventListener("error", uploadFailed, false);
  // xhr.addEventListener("abort", uploadCanceled, false);

  xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND

  xhr.send(fd);
}

export function uploadImageObj({ fieldUploadImage, rootPath = 'etc' }) {
  const $fieldUploadImage = $(fieldUploadImage);
  const $form = $fieldUploadImage.find('.image-upload-field__form');
  const $progressBar = $fieldUploadImage.find('.image-upload-field__bar');
  const $preview = $fieldUploadImage.find('.image-upload-field__preview');
  const $inputSrc = $fieldUploadImage.find('.image-upload-field__src-input');
  const $inputSrcHidden = $fieldUploadImage.find('.image-upload-field__src-input-hidden');
  $form.fileupload({
    url: $form.attr('action'),
    type: 'POST',
    datatype: 'xml',
    change(e, data) {
      if (!/\.(jpg|jpeg|png)$/i.test(data.files[0].name)) {
        const ext = data.files[0].name.split('.').pop();
        alert(`Not Allowed ${ext} files. Only jpg, jpeg, png files are allowed.`);
        return false;
      }
    },
    add(event, data) {
      const fileRelativePath = `${rootPath}/${fileName(data)}`;
      occoApi.photoTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
        if (err) {
          return alert(err.message_key);
        }
        $form.attr('action', result.url);
        $form.find('input[name=key]').val(fileRelativePath);
        $form.find('input[name=Content-Type]').val(data.files[0].type);
        $form.find('input[name=X-Amz-Credential]').val(result.fields['X-Amz-Credential']);
        $form.find('input[name=X-Amz-Algorithm]').val(result.fields['X-Amz-Algorithm']);
        $form.find('input[name=X-Amz-Date]').val(result.fields['X-Amz-Date']);
        $form.find('input[name=X-Amz-Security-Token]').val(result.fields['X-Amz-Security-Token']);
        $form.find('input[name=Policy]').val(result.fields.Policy);
        $form.find('input[name=X-Amz-Signature]').val(result.fields['X-Amz-Signature']);

        // Message on unLoad.
        window.onbeforeunload = function () {
          return LANG.unsaved_message;
        };
        // Submit
        data.submit();
      });
    },
    send() {},
    progress(e, data) {
      if ($progressBar) {
        const percent = Math.round((data.loaded / data.total) * 100);
        $progressBar.css('width', `${percent}%`);
      }
    },
    fail(e, data) {
      // Remove 'unsaved changes' message.
      window.onbeforeunload = null;
      $progressBar.css('width', `${0}%`);
    },
    success(data) {
      // onSuccess
      const filePath = $(data).find('Key')[0].childNodes[0].nodeValue;
      const originalSrc = `${REAL_IMAGE_PATH}/${filePath}`;
      if ($preview) {
        $preview.attr('src', originalSrc);
      }
      if ($inputSrc) {
        $inputSrc.val(originalSrc);
        $inputSrcHidden.val(originalSrc);
      }
    },
    done(event, data) {},
  });

  function fileName(data) {
    return generateRandomFileName(data.files[0].name);
  }
}

export function uploadImage(formId, imageContId, progresId, valInputId, eventId, generateFileName, fileRootPath) {
  const form = $(`#${formId}`);
  form.fileupload({
    url: form.attr('action'),
    type: 'POST',
    datatype: 'xml',
    change(e, data) {
      if (!/\.(jpg|jpeg|png)$/i.test(data.files[0].name)) {
        const ext = data.files[0].name.split('.').pop();
        alert(`Not Allowed ${ext} files. Only jpg, jpeg, png files are allowed.`);
        return false;
      }
    },
    add(event, data) {
      let fileName = data.files[0].name;
      if (generateFileName) {
        fileName = generateRandomFileName(fileName);
      }
      let rootPath = 'watermarks/';
      if (fileRootPath) {
        rootPath = fileRootPath;
      }
      const fileRelativePath = `${rootPath + eventId}/${fileName}`;
      occoApi.photoTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
        if (err) {
          return alert(err.message_key);
        }
        $(`#${formId}`).attr('action', result.url);
        $(`#${formId} input[name=key]`).val(fileRelativePath);
        $(`#${formId} input[name=Content-Type]`).val(data.files[0].type);
        $(`#${formId} input[name=X-Amz-Credential]`).val(result.fields['X-Amz-Credential']);
        $(`#${formId} input[name=X-Amz-Algorithm]`).val(result.fields['X-Amz-Algorithm']);
        $(`#${formId} input[name=X-Amz-Date]`).val(result.fields['X-Amz-Date']);
        $(`#${formId} input[name=X-Amz-Security-Token]`).val(result.fields['X-Amz-Security-Token']);
        $(`#${formId} input[name=Policy]`).val(result.fields.Policy);
        $(`#${formId} input[name=X-Amz-Signature]`).val(result.fields['X-Amz-Signature']);

        // Message on unLoad.
        window.onbeforeunload = function () {
          return LANG.unsaved_message;
        };
        // Submit
        data.submit();
      });
    },
    send(e, data) {
      // onSend
    },
    progress(e, data) {
      const percent = Math.round((data.loaded / data.total) * 100);
      if (progresId) {
        $(`.bar${progresId}`).css('width', `${percent}%`);
      }
    },
    fail(e, data) {
      // Remove 'unsaved changes' message.
      window.onbeforeunload = null;
      $(`.bar${progresId}`).css('width', `${0}%`);
    },
    success(data) {
      // onSuccess
      const filePath = $(data).find('Key')[0].childNodes[0].nodeValue;
      const fileName = fromUrlFilename($(data).find('Key')[0].childNodes[0].nodeValue);
      const originalSrc = `${REAL_IMAGE_PATH}/${filePath}`;
      if (imageContId) {
        $(`#${imageContId}`).attr('src', normaliseUrl(originalSrc));
      }
      if (valInputId) {
        $(`#${valInputId}`).val(fromUrlFilename(originalSrc));
        $(`#hidden${valInputId}`).val(originalSrc);
      }
    },
    done(event, data) {},
  });
}

export function reloadPage() {
  location.reload();
}

export function setCookie(cname, cvalue) {
  const d = new Date();
  d.setTime(d.getTime() + getQueryProvider.COOKIE_EXPIRE_DAYS * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

export function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function getFilteredImages(data) {
  let visibleImagesCount = 0;
  let hideImagesCount = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i].is_visible === 1) {
      visibleImagesCount++;
    } else {
      hideImagesCount++;
    }
  }
  return {
    visibleCount: visibleImagesCount,
    hideCount: hideImagesCount,
  };
}
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address

export function isEmail(email, multi) {
  let validEmail = true;
  if (multi) {
    const emails = email.split(',');
    if (emails && emails.length > 1) {
      $.each(emails, (index, value) => {
        if (!emailRegex.test(value)) {
          return false;
        }
      });
    } else {
      validEmail = emailRegex.test(emails[0]);
    }
  } else {
    validEmail = emailRegex.test(email);
  }
  return validEmail;
}

export function isPhoneNumber(number) {
  const regex = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g;
  return regex.test(number);
}

export function getOnlyNumbers(number) {
  if (!number) {
    return number;
  }
  return number.replace(/[^0-9]/gi, '');
}

export function isTemplate(template) {
  if (template.indexOf('{user_name}') != -1 && template.indexOf('{image_url}') != -1) {
    return true;
  }
  return false;
}

export function isReceiptEmailBody(template) {
  if (template.indexOf('{user_name}') != -1) {
    return true;
  }
  return false;
}

export function isTemplateShare(template) {
  // isTemplateShare
  if (template.indexOf('{image_url}') != -1) {
    return true;
  }
  return false;
}

export function isTemplateSMS(template) {
  if (template.indexOf('{user_name}') != -1 && template.indexOf('{image_url}') != -1) {
    return true;
  }
  return false;
}

export function showHtmlContent(id) {
  if (id) {
    $('#previewModal').modal('show');
    elId('previewBody').innerHTML = elId(id).value;
    console.log(elId('previewBody').innerHTML);
  }
}

export function closePreview() {
  $('#previewModal').modal('hide');
}

export function createjscssfile(filename, filetype) {
  let fileref;
  if (filetype == 'js') {
    // if filename is a external JavaScript file
    fileref = document.createElement('script');
    fileref.setAttribute('type', 'text/javascript');
    fileref.setAttribute('src', filename);
  } else if (filetype == 'css') {
    // if filename is an external CSS file
    fileref = document.createElement('link');
    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/css');
    fileref.setAttribute('href', filename);
  }
  return fileref;
}

export function replacejscssfile(oldfilename, newfilename, filetype) {
  const targetelement = filetype == 'js' ? 'script' : filetype == 'css' ? 'link' : 'none'; // determine element type to create nodelist using
  const targetattr = filetype == 'js' ? 'src' : filetype == 'css' ? 'href' : 'none'; // determine corresponding attribute to test for
  const allsuspects = document.getElementsByTagName(targetelement);
  for (let i = allsuspects.length; i >= 0; i--) {
    // search backwards within nodelist for matching elements to remove
    if (
      allsuspects[i] &&
      allsuspects[i].getAttribute(targetattr) != null &&
      allsuspects[i].getAttribute(targetattr).indexOf(oldfilename) != -1
    ) {
      const newelement = createjscssfile(newfilename, filetype);
      allsuspects[i].parentNode.replaceChild(newelement, allsuspects[i]);
    }
  }
}

export function shareOnFB(url, title, desc, imageUrl, hashtag) {
  FB.ui(
    {
      method: 'share_open_graph',
      action_type: 'og.shares',
      display: 'popup',
      hashtag,
      action_properties: JSON.stringify({
        object: {
          'og:url': url,
          'og:title': title,
          'og:description': desc,
          'og:image': imageUrl,
        },
      }),
    },
    (response) => {
      // Action after response
    }
  );
}

export function is_Super() {
  getQueryProvider.init();
  const role = Storage.getLocalItem('role');
  if (getQueryProvider.ALBUM_TYPES.isOccoOwnerAlbum && role === '1') {
    return true;
  }
  return false;
}

export function isSuperAdmin() {
  return is_Super();
}

export function is_Admin() {
  getQueryProvider.init();
  const role = Storage.getLocalItem('role');
  if (getQueryProvider.ALBUM_TYPES.isOccoOwnerAlbum && role === '2') {
    return true;
  }
  return false;
}

export function isAdmin() {
  return is_Admin();
}

export function hideFeaturesForNonAdminAndSuperAdmin() {
  if (!is_Super()) {
    $('.SUPERUSER').hide();
    if (!is_Admin()) {
      $('.ADMINUSER').hide();
    }
  }
}

export function setButtonShadow($el) {
  if (!isMobile.iPhone()) {
    $el.addClass('shadow');
  }
}

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

export function getQueryPath() {
  return window.location?.pathname ? window.location.pathname : '/';
}

export function isQueryVariableExist(variable) {
  return getQueryVariable(variable) !== false;
}

export function getHashVariable(variable) {
  const query = window.location.hash;
  const vars = query.split('#');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

$.support.touch = true;
const supportTouch = $.support.touch;
const scrollEvent = 'touchmove scroll';
const touchStartEvent = supportTouch ? 'touchstart' : 'mousedown';
const touchStopEvent = supportTouch ? 'touchend' : 'mouseup';
const touchMoveEvent = supportTouch ? 'touchmove' : 'mousemove';
$.event.special.swipeupdown = {
  setup() {
    const thisObject = this;
    const $this = $(thisObject);
    $this.bind(touchStartEvent, (event) => {
      const data = event.originalEvent.touches ? event.originalEvent.touches[0] : event;
      let start = {
        time: new Date().getTime(),
        coords: [data.pageX, data.pageY],
        origin: $(event.target),
      };
      let stop;

      function moveHandler(event) {
        if (!start) {
          return;
        }
        const data = event.originalEvent.touches ? event.originalEvent.touches[0] : event;
        stop = {
          time: new Date().getTime(),
          coords: [data.pageX, data.pageY],
        };

        // prevent scrolling
        if (Math.abs(start.coords[1] - stop.coords[1]) > 10) {
          event.preventDefault();
        }
      }
      $this.bind(touchMoveEvent, moveHandler).one(touchStopEvent, (event) => {
        $this.unbind(touchMoveEvent, moveHandler);
        if (start && stop) {
          if (
            stop.time - start.time > 300 && //  if (stop.time - start.time < 1000 &&
            Math.abs(start.coords[1] - stop.coords[1]) > 30 &&
            Math.abs(start.coords[0] - stop.coords[0]) < 75
          ) {
            start.origin.trigger('swipeupdown').trigger(start.coords[1] > stop.coords[1] ? 'swipeup' : 'swipedown');
          }
        }
        start = stop = undefined;
      });
    });
  },
};

$.each(
  {
    swipedown: 'swipeupdown',
    swipeup: 'swipeupdown',
  },
  (event, sourceEvent) => {
    $.event.special[event] = {
      setup() {
        $(this).bind(sourceEvent, $.noop);
      },
    };
  }
);

(function ($) {
  let isiOS = false;
  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    isiOS = true;
  }
  $.event.special.doubletap = {
    bindType: 'touchend',
    delegateType: 'touchend',

    handle(event) {
      if (isiOS) {
        const { handleObj } = event;
        const targetData = jQuery.data(event.target);
        const now = new Date().getTime();
        const delta = targetData.lastTouch ? now - targetData.lastTouch : 0;
        var delay = delay == null ? 250 : delay;

        if (delta < delay && delta > 50) {
          targetData.lastTouch = null;
          event.type = handleObj.origType;
          ['clientX', 'clientY', 'pageX', 'pageY'].forEach((property) => {
            event[property] = event.originalEvent.changedTouches[0][property];
          });

          // let jQuery handle the triggering of "doubletap" event handlers
          handleObj.handler.apply(this, arguments);
        } else {
          targetData.lastTouch = now;
        }
      }
    },
  };
})(jQuery);

export function isURL(str) {
  const regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  if (regexp.test(str)) {
    return true;
  }
  return false;
}

export function addHttp(url) {
  if (!/^(f|ht)tps?:\/\//i.test(url)) {
    url = `http://${url}`;
  }
  return url;
}

export function multiPopupFix() {
  $('.modal').on('hidden.bs.modal', (e) => {
    if ($('.modal:visible').length) {
      $('body').addClass('modal-open');
    }
  });

  // Fix accessibility: blur focused elements before hiding to prevent aria-hidden warning
  $('.modal').on('hide.bs.modal', function () {
    $(this).find(':focus').blur();
  });
}

export function activateMultiEmail(id) {
  $(`#${id}`).tagsInput({
    width: 'auto',
    pattern: emailRegex,
    defaultText: LANG.add_valid_email, // default: false
    height: '35px',
  });
}

export function activateMultiTagsInput(id) {
  $(`#${id}`).tagsInput({
    width: 'auto',
    pattern: /^[a-zA-Z0-9-_]+$/,
    height: '100px',
  });
}

export function activateMultiRegiredTagsToCreateStoryInput(id) {
  $(`#${id}`).tagsInput({
    width: 'auto',
    pattern: /^[a-zA-Z0-9-_]+$/,
    height: '60px',
  });
}

export function activateEmailautoComplete(id, email_ends) {
  $(`#${id}`).mailtip({
    mails: email_ends,
    zIndex: 100000,
  });
}

export function getEmployeeCode(code) {
  const codeval = elId(`evUnlockCode_${code}`).value;
  const firstname = elId(`enFirstname_${code}`).value;
  const lastname = elId(`enLastname_${code}`).value;
  return `${firstname}_${lastname}_${codeval}`;
}

export function getQRcode(code) {
  const text = getEmployeeCode(code);
  const firstname = elId(`enFirstname_${code}`).value;
  const lastname = elId(`enLastname_${code}`).value;
  const $qrCodeCont = $('#qrCodeCont');
  $qrCodeCont.qrcode({
    text,
    size: 500,
    mode: 0,
    mSize: 0.045,
    mPosX: 0.5,
    mPosY: 0.5,
    fontcolor: '#000',
    fontname: 'Arial',
    ecLevel: 'H',
    render: 'image',
  });
  const a = document.createElement('a');
  a.href = $('#qrCodeCont img:first').attr('src');
  a.download = `${firstname}_${lastname}`;
  $qrCodeCont.html(a);
  a.click();
  $qrCodeCont.html('');
}

export function getEventQRcode(eventName) {
  const link = `${window.PHOTO_STREAM_SITE_URL}/?ename=${eventName}&mode=qrcode`;
  const label = `${window.PHOTO_STREAM_SITE_URL.replace(/(^\w+:|^)\/\//, '')}/${eventName}`;
  const $qrCodeCont = $('#qrCodeCont');
  $qrCodeCont.qrcode({
    text: link,
    label,
    size: 1000,
    mode: 1,
    mSize: 0.045,
    mPosX: 0.5,
    mPosY: 0.5,
    fontcolor: '#000',
    fontname: 'Arial',
    ecLevel: 'H',
    render: 'image',
  });
  const a = document.createElement('a');
  a.href = $('#qrCodeCont img:first').attr('src');
  a.download = `QRcode_${eventName}`;
  $qrCodeCont.html(a);
  a.click();
  $qrCodeCont.html('');
}

export function getKioskQRImage(text, size) {
  const $qrCodeCont = $('#qrCodeContKiosks');
  $qrCodeCont.empty();
  $qrCodeCont.qrcode({
    text,
    label: text,
    size: size || DEFAULT_QR_SIZE,
    mode: 0,
    mSize: 0.045,
    mPosX: 0.5,
    mPosY: 0.5,
    fontcolor: '#000',
    ecLevel: 'H',
    render: 'image',
  });
  // console.log(text)
  return $('#qrCodeContKiosks img:first').attr('src');
}

export function generateUrlForQR({ url, imgSrc, photoId, eventName }) {
  let link = `${url}?imgSrc=${imgSrc}&photoId=${photoId}`;
  if (eventName) {
    link += `&eName=${eventName}`;
  }
  return link;
}

export var bracketTextUtil = {
  setTextInBrackets(str, bracketText) {
    return str.replace(/\{.*?\}/, bracketText);
  },
  getBracketText(str) {
    const str_arr = str.match(/\{([^)]+)\}/);
    if (str_arr && str_arr[1]) {
      return str_arr[1];
    }
    return str;
  },
};

String.prototype.replaceAll = function (search, replacement) {
  const target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};

export function getRotationDegrees(x1, y1, x2, y2) {
  let angle = 0;
  const width = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  const sinX = (y2 - y1) / width;
  const cosX = (x2 - x1) / width;
  const rotationRadians = Math.asin(sinX);
  const RAD2DEG = 180 / Math.PI;
  angle = rotationRadians * RAD2DEG;
  if (sinX < 0 && cosX < 0) angle = -180 - angle;
  if (sinX > 0 && cosX < 0) angle = 180 - angle;
  return angle;
}

export function radToDegree(radians) {
  const pi = Math.PI;
  return radians * (180 / pi);
}

export function htmlTagRemoval(str) {
  return str.replace(/(<([^>]+)>)/gi, ' ');
}

export function getFileName(path) {
  let value = path.match(/[-_\w]+[.][\w]+$/i)[0];
  if (value) {
    value = value.split('.').shift();
  }
  return value;
}

(function ($) {
  $.fn.button = function (action) {
    if (action === 'loading' && this.data('loading-text')) {
      this.data('original-text', this.html()).html(this.data('loading-text')).prop('disabled', true);
    }
    if (action === 'reset' && this.data('original-text')) {
      this.html(this.data('original-text')).prop('disabled', false);
    }
  };
})(jQuery);

export function filterNumberInput(event) {
  const keyCode = 'which' in event ? event.which : event.keyCode;
  const isNotWanted = !(keyCode === 8 || keyCode === 46 ? true : !isNaN(Number(event.key)));
  return !isNotWanted;
}

export function isValidExtension(extension) {
  if (/(jpg|jpeg|png|gif|mp4)$/gi.test(extension)) {
    return true;
  }
  return false;
}

export function refreshPage(actionName) {
  alertMessagePopup(LANG.something_wrong);
}

export function checkAttendee(attendeeId, callbackSuccess, callbackError) {
  occoApi.getAttendee(attendeeId, (err, result) => {
    if (err) {
      if (callbackError) {
        callbackError(err);
      } else if (err.type == 'occo') {
        alertMessagePopup(t('welcome-invalid-attendee-id-message'));
      }
      return;
    }

    callbackSuccess(result);
  });
}

export function newFacebookShare(photo_id, photo_uid, event_name, hashtag) {
  const data_fb_share_url = $(`#item_${photo_id}`).data('fb-share-url');
  const robot_id = $(`#item_${photo_id}`).data('robot-id');
  trackPhotoEvent('FacebookShare', photo_id, robot_id);
  if (typeof data_fb_share_url !== 'undefined' && data_fb_share_url !== false) {
    window.open(data_fb_share_url, '_blank');
    return;
  }
  showLoading();
  occoApi.generateHtmlForFileSharing(photo_uid, event_name, (err, result) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
    hideLoading();
    if (result) {
      const pageUrl = `${FACEBOOK_SHARE_URL + encodeURIComponent(result)}&redirect_uri=${encodeURIComponent(
        'https://www.facebook.com/'
      )}${hashtag}`;
      $(`#item_${photo_id}`).data('fb-share-url', pageUrl);
      window.open(pageUrl, '_blank');
    }
  });
}

export function checkAttendeeIdPrivateIdComp(attendeeId, privateId, callback) {
  occoApi.getAttendeePrivateIdComp(attendeeId, privateId, (err, result) => {
    if (err) {
      if (err.type == 'occo') {
        alertMessagePopup(t('welcome-invalid-attendee-id-message'));
      }
      return;
    }

    callback(result);
  });
}
export const blockOverlay = {
  hide() {
    $('.block-overlay').hide();
  },
  show() {
    $('.block-overlay').show();
  },
};

export function genRandomCode(input) {
  const rand = Math.random().toString(36).substring(2, 6).toUpperCase();
  if (input) {
    input.value = rand;
  } else {
    return rand;
  }
}

export function addNewUnlockCode(firstname, lastname, code) {
  let randId = null;
  if (code) {
    randId = code;
  } else {
    randId = genRandomCode();
  }
  let firstNameValue = '';
  if (firstname) {
    firstNameValue = firstname;
  }
  let lastNameValue = '';
  if (lastname) {
    lastNameValue = lastname;
  }
  const str =
    `<div class="form-row">` +
    `<div class="col">` +
    `<label >First Name</label>` +
    `<input type="text" id="enFirstname_${randId}" class="form-control" placeholder="Firstname" value="${firstNameValue}">` +
    `</div>` +
    `<div class="col">` +
    `<label >Last Name</label>` +
    `<input type="text" id="enLastname_${randId}" class="form-control" placeholder="Lastname" value="${lastNameValue}">` +
    `</div>` +
    `<div class="col-6">` +
    ` <label >Unlock Code</label>` +
    `<div class="input-group mb-3">` +
    `<input type="text" class="form-control" id="evUnlockCode_${randId}" value="${randId}" disabled>` +
    ` <div class="input-group-append">` +
    `<button class="btn btn-sm btn-secondary" type="button" onclick="genRandomCode(elId('evUnlockCode_${randId}'))"><i class="fas fa-random"></i></button>` +
    ` </div>` +
    `<div class="input-group-append">` +
    `<button class="btn btn-sm btn-dark" type="button" onclick="getQRcode('${randId}')"><i class="fas fa-qrcode"></i></button>` +
    `</div>` +
    `<div class="input-group-append">` +
    `<button class="btn btn-sm btn-dark" type="button" onclick="addToClipboard(getEmployeeCode('${randId}'))"><i class="fas fa-copy"></i></button>` +
    `</div>` +
    `</div>` +
    `</div>` +
    `</div>`;
  const $unlockEventCont = $('#unlockEventCont');
  $unlockEventCont.append(str);
}

export function showModalForFreedomPayOfflineTransactionCheck() {
  let checkStatusContent = `<div class="confirm-purchase-popup"><H3>${t('freedompay-offline-request-title')}</H3><br>`;
  checkStatusContent +=
    '<br><input type="text" class="form-control form-control-sm" id="freedomPaytransactionRequestId" autocomplete="off" autofocus><br>' +
    '<button type="button" id="backApproved" onclick="customPopUp.hide()" class="btn btn-secondary" >CLOSE</button>&nbsp;&nbsp;' +
    '<button type="button" id="freedomPaytransactionRequestIdEntered" class="btn btn-primary btn-yes-purchase">OK</button><br><br>' +
    '</div>';
  customPopUp.html(checkStatusContent);
  customPopUp.show();
  window.customPopUp = customPopUp;
  elId('freedomPaytransactionRequestIdEntered').onclick = function () {
    const freedomPaytransactionRequestId = elId('freedomPaytransactionRequestId').value;
    showLoading();
    freedomPayAPI.checkOfflineTransactionStatus(freedomPaytransactionRequestId, (err, result) => {
      hideLoading();
      if (err) {
        console.log(err);
        alertMessagePopup('Status check failed');
        return;
      }
      alertMessagePopup(`Error code - ${result.ErrorCode} ${result.Message}`);
    });
  };
}

export function showModalForSquareDeviceSetUp() {
  if (SQUARE_ACCESS_TOKEN && SQUARE_LOCATIONS) {
    _createDeviceCodeFields();
    return;
  }
  let accessTokenContent = `<div class="confirm-purchase-popup"><H3>${t('square-reader-access-token-title')}</H3><br>`;
  accessTokenContent +=
    '<br><input type="password" class="form-control form-control-sm" id="squareAccessToken" autocomplete="off" autofocus><br>' +
    '<button type="button" id="backApproved" onclick="customPopUp.hide()" class="btn btn-secondary" >CLOSE</button>&nbsp;&nbsp;' +
    '<button type="button" id="squareAccessTokenEntered" class="btn btn-primary btn-yes-purchase">OK</button><br><br>' +
    '</div>';
  customPopUp.html(accessTokenContent);
  customPopUp.show();
  elId('squareAccessTokenEntered').onclick = function () {
    const squareAccessToken = elId('squareAccessToken').value;
    showLoading();
    occoApi.getSquareLocations(squareAccessToken, (err, result) => {
      hideLoading();
      if (err) {
        alertMessagePopup(err.resp.error_message);
        return;
      }
      SQUARE_ACCESS_TOKEN = squareAccessToken;
      SQUARE_LOCATIONS = result.locations;
      customPopUp.hide();
      _createDeviceCodeFields();
      $('#addNewSquareReaderButton').prop('disabled', true);
    });
  };
}

export function _createDeviceCodeFields() {
  console.log(LANG);
  let select = `<select class="custom-select" id="squareLocations${SQUARE_DEVICE_COUNT}">`;
  select += `<option value='' selected>${LANG.select_square_locations}</option>`;
  for (let i = 0; i < SQUARE_LOCATIONS.length; i++) {
    select += `<option value=${SQUARE_LOCATIONS[i].id}>${SQUARE_LOCATIONS[i].name}</option>`;
  }
  select += '</select>';
  const str =
    `<div class="form-row" id="deviceFieldsRow"${SQUARE_DEVICE_COUNT}>` +
    `<div class="col">` +
    `<label >Device Name</label>` +
    `<input type="text" id="deviceName${SQUARE_DEVICE_COUNT}" class="form-control" placeholder="Device Name">` +
    `</div>` +
    `<div class="col locationsSelectDiv">` +
    `<label >Locations</label>` +
    `<div class="input-group mb-3">${select}<div class="col-sm-auto">` +
    `<button type="button" onclick="createDeviceCode(${SQUARE_DEVICE_COUNT})" class="btn btn-sm btn-primary"> Create Device </button>` +
    `</div>` +
    `</div>` +
    `</div>` +
    `</div>`;
  const $deviceCodeFields = $('#deviceCodeFields');
  $deviceCodeFields.append(str);
  SQUARE_DEVICE_COUNT++;
}

export function createDeviceCode(index) {
  const deviceName = elId(`deviceName${index}`).value;
  const locationId = elId(`squareLocations${index}`).value;
  let device_code_id;
  if (!deviceName) {
    alertMessagePopup(LANG.square_device_name_required);
    return;
  }
  if (!locationId) {
    alertMessagePopup(LANG.square_location_required);
    return;
  }
  showLoading();
  occoApi.createSquareDeviceCode(SQUARE_ACCESS_TOKEN, deviceName, locationId, (err, result) => {
    hideLoading();
    if (err) {
      alertMessagePopup(LANG.square_create_device_error);
      return;
    }
    device_code_id = result.device_code.id; // This is the id of the device_code object that uniquely identifies that device_code
    let showDeviceCodeContent = `<div class="confirm-purchase-popup"><H3 id="signInHeader">${t('square-reader-pairing-code-title')}</H3><br>`;
    showDeviceCodeContent +=
      `<br><span class="form-control form-control">${result.device_code.code}</span><br>` +
      `<button type="button" id="getPairedDeviceButton" class="btn btn-primary btn-yes-purchase">OK</button><br><br>` +
      `</div>`;
    customPopUp.html(showDeviceCodeContent);
    customPopUp.show();
  });
  $('#customPopUpBody').on('click', '#getPairedDeviceButton', () => {
    showLoading();
    occoApi.getSquareDeviceCodeById(SQUARE_ACCESS_TOKEN, device_code_id, (err, result) => {
      hideLoading();
      if (err) {
        alertMessagePopup(LANG.square_get_device_error);
        return;
      }
      const { device_id } = result.device_code; // This is the id of the terminal(device)
      let content;
      if (!device_id) {
        elId('signInHeader').textContent = t('square-reader-still-unpaired-text');
        return;
      }
      const newAccessToken = SQUARE_ACCESS_TOKEN.split('').reverse().join('');
      content = `<div class="confirm-purchase-popup"><H3>${t('square-reader-security-note-title')}</H3><br>`;
      content += `<br><label>Access Token</label><input type="text" value="${newAccessToken}" class="form-control" disabled>`;
      content +=
        `<br><label>Device Id</label><input type="text" value="${device_id}" class="form-control" disabled>` +
        `<br><label>Kiosk Link Example</label><input type="text" value="{kiosk_page_name.html}?` +
        `kioskId=ks01&kioskPrintPoolPostFix=abcd&squareAccessToken=${newAccessToken}&deviceId=${device_id}" class="form-control" disabled><br><br>` +
        `<div class="col-sm-auto">` +
        `<button type="button" id="closeSquareInfoPopUp" class="btn btn-primary btn-yes-purchase">Close</button><br><br>` +
        `</div>`;
      ('</div>');
      customPopUp.html(content);
      customPopUp.show();
      $('#customPopUpBody').on('click', '#closeSquareInfoPopUp', () => {
        customPopUp.hide();
      });
      $('#addNewSquareReaderButton').prop('disabled', false);
      $('#deviceFieldsRow').remove();
    });
  });
}

export function getUnlockCodeList() {
  const codes = $('#unlockEventCont [id^=evUnlockCode_]');
  const firstnames = $('#unlockEventCont [id^=enFirstname_]');
  const lastnames = $('#unlockEventCont [id^=enLastname_]');
  const unCodeArr = [];
  for (let i = 0; i < codes.length; i++) {
    if (firstnames[i].value && lastnames[i].value && codes[i].value) {
      unCodeArr.push(`${firstnames[i].value}_${lastnames[i].value}_${codes[i].value}`);
    }
  }
  return unCodeArr.join(',');
}

export function setUnlockCodes(codes) {
  if (codes) {
    codes = codes.split(',');
  }

  for (let i = 0; i < codes.length; i++) {
    const splitetFn = codes[i].split('_')[0];
    const splitetLn = codes[i].split('_')[1];
    const splitetCode = codes[i].split('_')[2];
    addNewUnlockCode(splitetFn, splitetLn, splitetCode);
  }
}

export function getKioskHtmlTemplate(varObj) {
  const invalidStoriCardText = JSON.stringify(t('storicard-invalid-code-text'));
  const str =
    `<!DOCTYPE html>` +
    `<html>` +
    `` +
    `<head>` +
    `    <meta charset="utf-8">` +
    `    <meta name="robots" content="noindex">` +
    `    </meta>` +
    `    <meta http-equiv="X-UA-Compatible" content="IE=edge">` +
    `    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />` +
    `    <link rel="icon" href="favicon.ico" type="image/x-icon">` +
    `    <title>RB_GATLINBURG_BHGI_1</title>` +
    `    <style>` +
    `        body {` +
    `            font-family: Arial, sans-serif;` +
    `            background-color: #00bb77;` +
    `            background-image: url("KioskRBGatlinburg.gif");` +
    `            background-size: cover;` +
    `        }` +
    `` +
    `        .cardScan {` +
    `            margin: 0 auto;` +
    `            position: fixed;` +
    `            bottom: 0px;` +
    `            left: 50%;` +
    `            -ms-transform: translate(-50%, -50%);` +
    `            transform: translate(-50%, -50%);` +
    `        }` +
    `` +
    `        #scanCardInput {` +
    `            width: 100%;` +
    `            padding: 12px 20px;` +
    `            display: inline-block;` +
    `            border: 1px solid #ccc;` +
    `            border-radius: 4px;` +
    `            box-sizing: border-box;` +
    `            font-size: 35px;` +
    `        }` +
    `` +
    `        #error {` +
    `            color: #fff;` +
    `            text-align: center;` +
    `            padding-top: 35px;` +
    `            font-size: 25px;` +
    `        }` +
    `    </style>` +
    `</head>` +
    `` +
    `<body>` +
    `    <div class="cardScan"> <input type="password" id="scanCardInput" autofocus />` +
    `        <div id="error"></div>` +
    `    </div>` +
    `    <script type="text/javascript">` +
    `        var varObj =${varObj}    </script>` +
    `    <script src="https://code.jquery.com/jquery-3.5.1.min.js"` +
    `        integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=" crossorigin="anonymous"></script>` +
    `    <script src="https://storibox.com/js/utils.js?v=1"></script>` +
    `    <script type="text/javascript">` +
    `        var kioskPreviewSize = getQueryVariable("kps") || null;` +
    `        var miniAlbumPreviewSize = getQueryVariable("maps") || null;` +
    `        var scanCardInput = document.getElementById("scanCardInput");` +
    `        /* scanCardInput.oninput = function () {` +
    `             var valId = getAttId(this.value);` +
    `             if (valId.length === 16) {` +
    `                 gotoEvent(valId);` +
    `             }` +
    `         };*/` +
    `        scanCardInput.addEventListener("keyup", function (event) {` +
    `            if (event.keyCode === 13) {` +
    `                event.preventDefault();` +
    `                gotoEvent(getAttId(this.value));` +
    `            }` +
    `        });` +
    `` +
    `        function getAttId(url) {` +
    `            if (url.indexOf("attId") !== -1) {` +
    `                var index = (url.indexOf("=") !== -1) ? url.indexOf("=") + 1 : -1;` +
    `                return url.slice(index).split("-").join("");` +
    `            } else {` +
    `                return url;` +
    `            }` +
    `        }` +
    `` +
    `        function gotoEvent(attId) {` +
    `            attendeePrivateIdValidation(attId, varObj.pvId, function (status) {` +
    `                if (status === true) {` +
    `            var url = "${window.EVENTS_SITE_URL}";` +
    `                    var params = "";` +
    `                    var home = location.origin+location.pathname;` +
    `                    switch (varObj.kioskModeSel) {` +
    `                        case "all":` +
    `                            params = "?kType=evSB1&pvId=" + varObj.pvId + "&attendeeId=" + attId + "&pModel=" +` +
    `                                JSON.stringify(` +
    `                                    varObj.pricing) + "&stHtmlUrl=" + home + "&kioskMode=true" +` +
    `                                "&kioskPreviewSize=" + kioskPreviewSize + "&miniAlbumPreviewSize=" +` +
    `                                miniAlbumPreviewSize;` +
    `                            break;` +
    `                        case "preselected":` +
    `                            params = "?kType=evSB2&privateId=" + varObj.pvId + "&attId=" + attId + "&pModel=" +` +
    `                                JSON.stringify(` +
    `                                    varObj.pricing) + "&stHtmlUrl=" + home + "&kioskMode=true" +` +
    `                                "&kioskPreviewSize=" + kioskPreviewSize + "&miniAlbumPreviewSize=" +` +
    `                                miniAlbumPreviewSize;` +
    `                            break;` +
    `                    };` +
    `                    $("#error").html("");` +
    `                    setTimeout(function () {` +
    `                        location.href = url + (encodeURI(params));` +
    `                    }, 500);` +
    `                } else {` +
    `                    $("#error").html(${invalidStoriCardText})` +
    `                }` +
    `            })` +
    `        }` +
    `    </script>` +
    `</body>` +
    `` +
    `</html>`;

  return str;
}
export var pricingMethods = {
  addNewPricingButton(firstButton) {
    const $pricingButtonsCont = $('#pricingButtonsCont');
    if (firstButton) {
      $pricingButtonsCont.html('');
      $pricingButtonsCont.attr('id_inc', 0);
    }
    let printerPoolsArray = [];
    if (occoEvent.getSelectedEventParam('printerPoolList')) {
      printerPoolsArray = occoEvent.getSelectedEventParam('printerPoolList').split(',');
    }
    let idInc = $pricingButtonsCont.attr('id_inc');
    const str =
      `<div class="form-row">` +
      `                            <div class="col-4">` +
      `                                <label for="">Purchase option button text on Kiosk</label>` +
      `                                <input type="text" id="prButt_${idInc}" class="form-control"` +
      `                                    placeholder="Unlock Digitals Only({Final_Amount})">` +
      `                            </div>` +
      `                            <div class="col-5">` +
      `                                <label for="">Price Formula</label>` +
      `                                <input type="text" id="prFm_${idInc}" class="form-control" placeholder="7.99-7.99*{USER_TYPE}">` +
      `                            </div>` +
      `                            <div class="col-3">` +
      `                                <label for="">Actions</label>` +
      `                                <div class="form-check check-left">` +
      `                                    <input class="form-check-input" id="prDigCheck_${idInc}"  type="checkbox" value="">` +
      `                                    <label class="form-check-label check-label-align" for="defaultCheck1">` +
      `                                        Unlock digitals` +
      `                                    </label>` +
      `                                </div>` +
      `                                <div class="form-row">` +
      `                                    <div class="col-5">` +
      `                                        <div class="form-check check-left">` +
      `                                            <input class="form-check-input" id="prPrintCheck_${idInc}"  type="checkbox" value="">` +
      `                                            <label class="form-check-label check-label-align" for="defaultCheck1">` +
      `                                                Print pool` +
      `                                            </label>` +
      `                                        </div>` +
      `                                    </div>` +
      `                                    <div class="col-7">${arrayToDropdown(
        `prPrintPool_${idInc}`,
        'input-sm small-input',
        printerPoolsArray
      )}                                    </div>` +
      `                                </div>` +
      `                            </div>` +
      `                        </div><hr>`;
    $pricingButtonsCont.append(str);
    idInc++;
    $pricingButtonsCont.attr('id_inc', idInc);
  },
  getPricingButtons() {
    const $pricingButtonsCont = $('#pricingButtonsCont');
    const idInc = $pricingButtonsCont.attr('id_inc');
    const buttonsArr = [];
    for (let i = 0; i < idInc; i++) {
      buttonsArr.push({
        buttonText: elId(`prButt_${i}`).value,
        priceFormula: elId(`prFm_${i}`).value,
        digitals: elId(`prDigCheck_${i}`).checked,
        prints: elId(`prPrintCheck_${i}`).checked,
        partialUnlockTags: elId(`prPartialUnlockTags_${i}`).checked,
        printsPool: elId(`prPrintPool_${i}`).value,
      });
    }
    return buttonsArr;
  },
};

export function disableImageResize() {
  $('.resize-icon').css('display', 'none');
  $('.select-image').css('top', '0px');
  $('.selIcon').css('bottom', '5px');
}

export function activatePaypalPurchase(price, attId, callbackSuccess) {
  if ($('#paypal-button').length) {
    return;
  }
  $('#customButtons').html('Unlock Your Photos<div id="paypal-button"></div>');
  $.getScript('https://www.paypalobjects.com/api/checkout.js', () => {
    const paypalClient = {};
    if (window.PAYPAL_ENV === 'production') {
      paypalClient.production = window.PAYPAL_CLIENT_ID;
    } else {
      paypalClient.sandbox = window.PAYPAL_CLIENT_ID;
    }
    paypal.Button.render(
      {
        // Configure environment
        env: window.PAYPAL_ENV,
        client: paypalClient,
        style: {
          size: 'medium',
          color: 'gold',
          shape: 'pill',
          label: 'checkout',
          tagline: 'true',
          layout: 'horizontal',
          fundingicons: 'true',
        },
        funding: {
          allowed: [paypal.FUNDING.CARD],
        },
        // Enable Pay Now checkout flow (optional)
        commit: true,

        // Set up a payment
        payment(data, actions) {
          return actions.payment.create({
            intent: 'sale',
            application_context: {
              brand_name: 'Storibox',
              shipping_preference: 'NO_SHIPPING',
            },
            payer: {
              payer_info: {
                first_name: 'Storibox',
              },
            },
            transactions: [
              {
                amount: {
                  total: price,
                  currency: 'USD',
                },

                description: 'Unlock your digital photos.',
                custom: attId,
                payment_options: {
                  allowed_payment_method: 'INSTANT_FUNDING_SOURCE',
                },
                soft_descriptor: attId,
                item_list: {
                  items: [
                    {
                      name: 'Full access to my Storibox digital content',
                      description: '',
                      quantity: '1',
                      price,
                      tax: '0',
                      sku: attId,
                      currency: 'USD',
                    },
                  ],
                },
              },
            ],
          });
        },
        experience: {
          input_fields: {
            no_shipping: 0,
          },
        },
        // Execute the payment
        onAuthorize(data, actions) {
          return actions.payment.execute().then((d) => {
            callbackSuccess(data, d);
          });
        },
      },
      '#paypal-button'
    );
  });
}

export function get360url(normalImageUrl) {
  return `${OCCO_360_VIEWER_PATH}?url=${normalImageUrl}`;
}

export function open360Viewer(url, paid) {
  let wmStr = '';
  if (paid) {
    wmStr = '&wm=111';
  }
  window.open(`${get360url(url)}&closeable=true${wmStr}`);
}

export function closeVideoPreview(type, videoId) {
  $('#customPopUp .modal-dialog').css('max-width', MAX_WIDTH_VIDEO_PREVIEW);
  if (type === 'video' && videoId) {
    $(videoId).trigger('pause');
  }
  customPopUp.hide();
}

export function openVideoPreview(url, isEnabledWatermarkKiosk = false, protectorWatermark = '', videoId) {
  MAX_WIDTH_VIDEO_PREVIEW = $('#customPopUp .modal-dialog').css('max-width');
  $('#customPopUp .modal-dialog').css('max-width', '95%');

  const content = `
    <div class="video-modal">
            <div class="watermark-wrapper">
              ${renderWatermark(isEnabledWatermarkKiosk, protectorWatermark)}
              <video id="${videoId}" autoplay loop width="100%">
                <source src="${url}" type="video/mp4">
              </video>
            </div>

            <button type="button" class="btn btn-primary" onclick="closeVideoPreview('video',${videoId})" style="margin-top: 15px">Close</button>
    </div`;
  customPopUp.html(content);
  customPopUp.show();

  function renderWatermark(isEnabled, src) {
    if (!isEnabled) return '';
    return `<div class="watermark-wrapper__watermark" style="background-image:url(${src})"></div>`;
  }
}

export function openPhotoPreview(url, isEnabledWatermarkKiosk = false, protectorWatermark = '') {
  MAX_WIDTH_VIDEO_PREVIEW = $('#customPopUp .modal-dialog').css('max-width');
  $('#customPopUp .modal-dialog').css('max-width', '95%');
  let content = '';
  if (isEnabledWatermarkKiosk) {
    content = `<div class="image-modal">
            <div class="watermark-wrapper">
              <div class="watermark-wrapper__watermark" style="background-image:url(${protectorWatermark})"></div>
              <img width="100%" height="100%" src="${url}"/>
            </div>`;
  } else {
    content = `<div class="image-modal">
            <img width="100%" height="100%" src="${url}"/>`;
  }
  content += `<button type="button" class="btn btn-primary" onclick="closeVideoPreview('photo')" style="margin-top: 15px">${t('close-btn')}</button>
                 </div>`;
  customPopUp.html(content);
  customPopUp.show();
}

export function arrayToDropdown(id, customCss, arr) {
  let cssClass = '';
  if (customCss) {
    cssClass = customCss;
  }
  let str = `<input id='${id}' class='form-control input-sm small-input'>`;
  if (arr.length > 0) {
    str = `<select id='${id}' class='form-control ${cssClass}'>`;
    for (let i = 0; i < arr.length; i++) {
      str += `<option value='${arr[i]}'>${arr[i]}</option>`;
    }
    str += '</select>';
  }
  return str;
}

export function getIPUrl(originalImage, bgRemovedImage, originalId) {
  const encodedOriginalImage = encodeURIComponent(originalImage)
  const encodedBgRemovedImage = encodeURIComponent(bgRemovedImage)
  return `${OCCO_IMAGE_PROCESSOR_PATH}?i1=${encodedOriginalImage}&i2=${encodedBgRemovedImage}&oid=${originalId}`;
}

export function goToImageProcessor(originalImage, bgRemovedImage, originalId) {
  window.open(getIPUrl(originalImage, bgRemovedImage, originalId));
}

export function getFilterCheckboxValue(checkboxGroupName) {
  const $checkboxGroup = $(`input[name='${checkboxGroupName}']:checked`);
  let val = null;
  if ($checkboxGroup.length === 1) {
    val = +$checkboxGroup.val();
  }
  return val;
}

/**
 * @param  {} isVisible  - v
 * @param  {} isOriginal - o
 * @param  {} isCuratable - c
 * @param  {} isCurated - cd
 * @param  {} isPrintable - p
 * @param  {} isPrinted - pd
 * @param  {} attIdFilter - ai
 * @param  {} chosenRange - range
 */
export function getImageFiltersForLocation(
  isVisible,
  isOriginal,
  isCuratable,
  isCurated,
  isPrintable,
  isPrinted,
  attIdFilter,
  startDate,
  endDate,
  chosenRange,
  fileNameFilter
) {
  let locFilter =
    (isVisible != null ? `#v=${isVisible}` : '') +
    (isOriginal != null ? `#o=${isOriginal}` : '') +
    (isCuratable != null ? `#c=${isCuratable}` : '') +
    (isCurated != null ? `#cd=${isCurated}` : '') +
    (isPrintable != null ? `#p=${isPrintable}` : '') +
    (isPrinted != null ? `#pd=${isPrinted}` : '') +
    (attIdFilter != null ? `#ai=${attIdFilter}` : '') +
    (fileNameFilter != null ? `#fn=${fileNameFilter}` : '');
  if (chosenRange === 'CustomRange') {
    locFilter += (startDate != null ? `#d1=${startDate}` : '') + (endDate != null ? `#d2=${endDate}` : '');
  } else {
    locFilter += chosenRange != null ? `#rangeLabel=${chosenRange}` : '';
  }

  return locFilter;
}

export function setImageFiltersForLocation(locationFilter) {
  if (locationFilter !== '') {
    window.location.assign(locationFilter);
  } else {
    window.location.assign('#');
  }
}

export function fillTimeZoneList(dateUtcDiffHours) {
  dateUtcDiffHours = dateUtcDiffHours == null ? 0 : dateUtcDiffHours;
  let timeZoneOpt = "<select id='dateUtcDiffHours' class='form-control form-control-sm'>";
  for (let i = -12; i < 14; i++) {
    let timeZoneName;
    if (i >= 0) {
      timeZoneName = `UTC+${i < 10 ? `0${i}` : i}:00`;
    } else {
      timeZoneName = `${i > -10 ? `UTC-0${-1 * i}` : `UTC${i}`}:00`;
    }
    if (dateUtcDiffHours != null && i == dateUtcDiffHours) {
      timeZoneOpt += `<option value=${i} selected >${timeZoneName}</option>`;
    } else {
      timeZoneOpt += `<option value=${i} >${timeZoneName}</option>`;
    }
  }
  timeZoneOpt += '</select>';
  elId('timeZoneList').innerHTML = timeZoneOpt;
}

export function getCalendarRangeKey(calendarRanges, mergedRangeKey) {
  return Object.keys(calendarRanges).find((key) => key.replaceAll(' ', '') === mergedRangeKey);
}

export function isMatchRangeDateFilterNameToLast(range) {
  const rangeRegexp = /^(Last)\d+(Days|Hours)$/;
  return rangeRegexp.test(range);
}

export function getAttendeeIdFromFullPath(fullPath) {
  let uid = '';
  const uidRegexp = /.+(uid_).+(_uid).+/g;
  if (uidRegexp.test(fullPath)) {
    const start = fullPath.indexOf('uid_');
    const end = fullPath.indexOf('_uid');
    uid = fullPath.slice(start + 4, end);
  }
  return uid;
}

export function getWatermarkImg() {
  const watermark = occoEvent.getSelectedEventParam('protectorWatermark');
  if (watermark === './img/wl_logo.png') {
    return WATERMARK_LOGO;
  }
  return watermark;
}

export function setWatermarkOnImages(protectorWatermarkURL, isSetToAll = false) {
  $(getCssPath()).css({
    'background-image': `url('${protectorWatermarkURL}')`,
    opacity: '1',
  });
  $('.occo-image').css({
    opacity: '0.9',
    '-webkit-touch-callout': 'none',
    '-webkit-text-size-adjust': 'none',
    '-webkit-user-select': 'none',
    '-webkit-user-drag': 'none',
    '-khtml-user-drag': 'none',
    '-moz-user-drag': 'none',
    '-o-user-drag': 'none',
    'user-drag': 'none',
  });

  function getCssPath() {
    if (isSetToAll) return '.select-image';
    return ".select-image[data-watermark='true']";
  }
}

export function prepareLinkToWebapp(eventName, { token } = {}) {
  let link = `${getWebappDomain()}?eName=${eventName}`;
  if (token) {
    link += `&token=${token}`;
  }
  return link;
}

export function getEventName() {
  return localStorage.getItem('eventName');
}

export function linkToWebapp() {
  return prepareLinkToWebapp(getEventName());
}

export function getLinkToWebappWithToken() {
  return prepareLinkToWebapp(getEventName(), {
    token: getValue('value', vipToken),
  });
}

export function copyLink() {
  addToClipboard(getLinkToWebappWithToken());
}

export function showLink() {
  alert(getLinkToWebappWithToken());
}

export function addToClipboard(text) {
  navigator.clipboard.writeText(text);
}

export function _detectPageInactive() {
  if (!PAGE_IS_ACTIVE) {
    setTimeout(() => {
      PAGE_IS_ACTIVE = false;
    }, PAGE_IS_ACTIVE_TIMEOUT);
  }
  PAGE_IS_ACTIVE = true;
}

export function isPageActive() {
  return PAGE_IS_ACTIVE;
}

export function detectActivePage() {
  window.addEventListener('mousemove', _detectPageInactive, false);
  window.addEventListener('mousedown', _detectPageInactive, false);
  window.addEventListener('keypress', _detectPageInactive, false);
  window.addEventListener('DOMMouseScroll', _detectPageInactive, false);
  window.addEventListener('mousewheel', _detectPageInactive, false);
  window.addEventListener('touchmove', _detectPageInactive, false);
  window.addEventListener('touchstart', _detectPageInactive, false);
  window.addEventListener('touchend', _detectPageInactive, false);
  window.addEventListener('touchcancel', _detectPageInactive, false);
  window.addEventListener('MSPointerMove', _detectPageInactive, false);
}

export function prepareLinkToRoamerapp(eventKey) {
  if (eventKey) {
    return `${process.env.ROAMERAPP_URL}?eventKey=${eventKey}`;
  }
  return process.env.ROAMERAPP_URL;
}

export function linkToRoamerapp() {
  const eventShareId = occoEvent.getSelectedEventParam('eventshareId');
  return prepareLinkToRoamerapp(eventShareId);
}

export function throttle(fn, timeout = 1000) {
  let isWaiting = false;
  return (...args) => {
    if (!isWaiting) {
      fn(...args);
      isWaiting = true;
      setTimeout(() => {
        isWaiting = false;
      }, timeout);
    }
  };
}

/**
 * Download file by url and set the name
 *
 * @param {String} url
 * @param {String} fileName
 */
export function downloadFile(url, fileName) {
  fetch(url)
    .then((res) => res.blob())
    .then((res) => {
      const aElement = document.createElement('a');
      aElement.setAttribute('download', fileName);
      const href = URL.createObjectURL(res);
      aElement.href = href;
      aElement.setAttribute('target', '_blank');
      aElement.click();
      URL.revokeObjectURL(href);
    })
    .catch((err) => {
      console.log('downloadFile error:', err);
    });
}

export function trackEventListOfPhotos({ activityName, photosId, robotId = null, activityType = 'info' }) {
  occoApi.activityBulkCreateByRobotId(robotId, photosId, activityName, activityType, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

export function initOneCallAtATime(promiseFn) {
  let isRunning = false;
  let lastPromise = null;

  return (...args) => {
    if (isRunning) {
      return lastPromise;
    }

    isRunning = true;
    lastPromise = promiseFn(...args);
    lastPromise.finally(() => {
      isRunning = false;
      lastPromise = null;
    });
    return lastPromise;
  };
}

export function setPageTitle(title) {
  $('.header-title').html(title);
}
export function resetAndEmptyInputs(inputs) {
  inputs.forEach((inputElement) => {
    const input = inputElement; // Created a local reference
    if (input) {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else if (input.tagName.toLowerCase() === 'select') {
        input.selectedIndex = 0;
      } else {
        input.value = '';
      }
    }
  });
}

export function setValueIfNotEmpty(obj, key, elementId) {
  const { value } = elId(elementId);
  if (value && value.trim() !== '') {
    return { ...obj, [key]: value };
  }
  return { ...obj, [key]: null };
}

export function startCountdown(duration, container, onComplete) {
  let timeLeft = duration;
  const interval = setInterval(() => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    // Format the time to MM:SS
    const formattedTime = `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    container.textContent = formattedTime;

    timeLeft--;

    if (timeLeft < 0) {
      clearInterval(interval);
      container.textContent = t('countdown-time-up-text');
      onComplete();
    }
  }, 1000);
}

export function getTrackerSnippetForEvent(eventCode) {
  return String.raw`<script src="${TRACKER_PATH}"></script>
   <script>
      OccoTracker.captureEvents({
        EventCode: "${eventCode}",   //Event Name
        TrackingKey: "Purchase", //Custom Key
      });
    </script>`;
}

export function getKioskAllowPhotoDelete() {
  const queryValue = getQueryVariable('allowKioskPhotoDelete');
  const localStorageValue = localStorage.getItem('allowKioskPhotoDelete');

  return queryValue === 'true' || localStorageValue === 'true';
}

export function kioskAllowPhotoDeleteConfirmation(callback) {
  const message = t('welcome-delete-photo-confirmation-message');
  const keepTxt = t('welcome-delete-photo-keep-btn');
  const deleteTxt = t('welcome-delete-photo-delete-btn');
  const content = `<div>
    <span class="kiosk-allow-photo-delete-message">${message} </span><br/> <br/>
     <button id="keepKioskPhotoDeleteBtn" type = "button" class = "btn btn-light btn-lg kiosk-allow-photo-keep-btn" data-dismiss = "modal" > ${keepTxt} </button><br/>
     <button id="deleteKioskPhotoBtn" type = "button" class = "btn btn-primary btn-lg kiosk-allow-photo-delete-btn" > ${deleteTxt} </button></div>`;
  customPopUp.html(content);
  customPopUp.show();
  $('#deleteKioskPhotoBtn').on('click', () => {
    callback();
    customPopUp.hide();
  });
}

export function getDefaultFromAddress() {
  return process.env.ENV_NAME === 'dev' ? 'dev-noreply@occo.io' : 'me@occo.me';
}

export function getUUID() {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
export function generateNewOccoApiToken() {
  const token = getUUID();
  const copyTokenButton = `<button type="button" onclick="navigator.clipboard.writeText('${token}')" class="btn btn-sm btn-secondary">Copy Token</button>`;
  const alertText = `${LANG.occoApiTokenResetWarning + token}&nbsp; &nbsp;${copyTokenButton}`;
  const customFooterHtml = `
 <button type="button" id="confirmCallback" class="btn btn-sm btn-success" data-dismiss="modal">Yes, Reset Token</button>
 <button type="button" class="btn btn-sm" data-dismiss="modal">Cancel</button>
 `;
  confirmPopup({
    title: 'Warning',
    body: alertText,
    customFooterHtml,
    callback: () => {
      elId('occoApiToken').value = token;
    },
  });
}

export function convertMessageKey(messageKey) {
  if (!messageKey) return '';
  let sentence = messageKey.replace(/_/g, ' ');
  sentence = sentence.charAt(0).toUpperCase() + sentence.slice(1);
  if (!sentence.endsWith('.')) {
    sentence += '.';
  }

  return sentence;
}
